// extracted by mini-css-extract-plugin
module.exports = {"container":"PackageContactCard_container__fIXCD","addSpace":"PackageContactCard_addSpace__TiQQH","cardMaxWidth":"PackageContactCard_cardMaxWidth__bj238"};